import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  clearError
} from '../duck/basic';
import {
  Button,
  Icon,
  Segment,
} from 'semantic-ui-react';

const ErrorView = (props) => (
  <Segment padded textAlign="center">
    <Icon
      size="massive"
      color="red"
      name="exclamation circle"
    />
    <h1>Hmm...</h1>
    {
      typeof(props.text) === 'string' &&
        <p>{props.text}</p>
    }
    {
      typeof(props.text) === 'object' &&
      <div>
        {
          props.text.map((t, i) => (
            <p key={i} style={{ fontWeight: 'bold', fontSize: '18px', color: 'red', marginBottom: '0' }}>- {t}</p>
          ))
        }
      </div>
    }
    {
      !props.hideClose &&
        <Button
          content="Close"
          basic
          onClick={props.clearError}
          style={{ marginTop: '20px' }}
        />
    }
  </Segment>
);

const mapDispatchToProps = dispatch => ({
  clearError: () => dispatch(clearError())
})

function mapStateToProps(state) {
  return {
    text: state.error
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorView);
